import { render } from "./Section2Adopt.vue?vue&type=template&id=c4bb19ee&scoped=true&ts=true"
import script from "./Section2Adopt.vue?vue&type=script&lang=ts"
export * from "./Section2Adopt.vue?vue&type=script&lang=ts"

import "./Section2Adopt.vue?vue&type=style&index=0&id=c4bb19ee&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c4bb19ee"]])

export default __exports__